<template>
  <v-card elevation="0" tile>
    <slot name="header">
      <v-card-title class="justify-center py-6 primary white--text text-subtitle-2" v-text="title"></v-card-title>
    </slot>
    <v-card-text class="pa-0 white" v-if="dataList != null">
      <v-list class="pa-0 px-2 ">
        <v-list-item :class="i !== 0 || title == null ? 'border-top' : ''" v-for="(info, i) in dataList" :key="i">
          <v-list-item-content class="justify-center py-1" v-text="info"></v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "BasicInfoCard",
  props: {
    title: {
      type: String
    },
    infoList: {
      type: Array
    }
  },
  computed: {
    dataList() {
      if (this.infoList == null || this.infoList.length === 0) return null;
      return this.infoList.filter(info => info != null && info !== "");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/variables.scss";

.v-application .text-subtitle-2 {
  font-family: $body-font-family;
}

.v-card__text,
.v-card__title {
  word-break: normal; /* maybe !important  */
}
</style>
